import * as _ from 'lodash';
import { Dimensions, Group, LoadsState, Position, RotateOptions, StackingOptions } from 'src/app/core/types';

export class LoadGroup {
  constructor(
    id: number,
    loadType: number,
    color: number,
    name: string,
    createdAt: number,
    quantity: number,
    weight: number,
    yRotation: number,
    edgeRotation: number,
    baseDimensions: Dimensions,
    position: Position,
    dimensions: Dimensions,
    loadsPerAxis: Position,
    properties: LoadsState,
    packed: number,
    maxLoadsOnTop: number | string,
    nameTranslated: string,
    showLoadName: boolean,
    centerOfMass: Position,
    rotateOptions?: RotateOptions,
    allowOutOfSpace?: boolean,
    pctSupport?: number,
    stackingOptions?: StackingOptions
  ) {
    this.id = id;
    this.loadType = loadType;
    this.color = color;
    this.name = name;
    this.createdAt = createdAt;
    this.quantity = quantity;
    this.weight = weight;
    this.yRotation = yRotation;
    this.edgeRotation = edgeRotation;
    this.baseDimensions = baseDimensions;
    this.position = {
      x: position.x,
      y: position.y,
      z: position.z,
    };
    this.dimensions = {
      length: dimensions.length,
      width: dimensions.width,
      height: dimensions.height,
      diameter: dimensions.diameter,
    };
    this.loadsPerAxis = loadsPerAxis;
    this.properties = properties;
    this.packed = packed;
    this.maxLoadsOnTop = maxLoadsOnTop;
    this.nameTranslated = nameTranslated;
    this.showLoadName = showLoadName;
    this.centerOfMass = centerOfMass;
    this.rotateOptions = rotateOptions;
    this.allowOutOfSpace = allowOutOfSpace;
    this.pctSupport = pctSupport;
    this.stackingOptions = stackingOptions;
  }

  public times100() {
    this.dimensions.length = _.round(this.dimensions.length * 100, 2);
    this.dimensions.width = _.round(this.dimensions.width * 100, 2);
    this.dimensions.height = _.round(this.dimensions.height * 100, 2);
    this.dimensions.diameter = _.round(this.dimensions.diameter * 100, 2);
    this.position.x = _.round(this.position.x * 100, 2);
    this.position.y = _.round(this.position.y * 100, 2);
    this.position.z = _.round(this.position.z * 100, 2);
  }

  public by100() {
    this.dimensions.length = _.round(this.dimensions.length / 100, 2);
    this.dimensions.width = _.round(this.dimensions.width / 100, 2);
    this.dimensions.height = _.round(this.dimensions.height / 100, 2);
    this.dimensions.diameter = _.round(this.dimensions.diameter / 100, 2);
    this.position.x = _.round(this.position.x / 100, 2);
    this.position.y = _.round(this.position.y / 100, 2);
    this.position.z = _.round(this.position.z / 100, 2);
  }
}

export interface LoadGroup {
  id: number;
  loadType: number;
  color: number;
  name: string;
  createdAt: number;
  quantity: number;
  weight: number;
  yRotation: number;
  edgeRotation: number;
  baseDimensions: Dimensions;
  position: Position;
  dimensions: Dimensions;
  loadsPerAxis: Position;
  properties: LoadsState;
  packed: number;
  maxLoadsOnTop: number | string;
  nameTranslated: string;
  showLoadName: boolean;
  isOptimization: boolean;
  centerOfMass: Position;
  rotateOptions?: RotateOptions;
  allowOutOfSpace?: boolean;
  pctSupport?: number;
  stackingOptions?: StackingOptions;
  palletContentGroups?: Group[];
  palletContentLoadGroups?: LoadGroup[];
}

export interface SessionGroup {
  color: number;
  name: string;
  createdAt: number;
  quantity: number;
  weight: number;
  stacking: boolean;
  dimensions: Dimensions;
  loadsCubes: LoadsCube[];
}

export interface LoadsCube {
  position: Position;
  loadsPerAxis: Position;
  state: LoadsState;
  dimensions: Dimensions;
  stacking?: boolean;
  rotateOptions?: RotateOptions
}
